/* eslint-disable import/no-extraneous-dependencies */
import { LitElement, html, nothing } from 'lit';
// import { TagKey } from '@cof/tag-catalog-fs-personal-mfe';
import typographyStyles from '@cof/fs-typography-core/lib/typography.lit.js';
import { FsIcon } from '@cof/fs-icon-wc/fs-icon.js';
import {
  fs24Offer,
  fs24Car,
  fs24Bank,
  fs24User,
  fs24Home,
  fs24MoneyBag,
  fs24CloseFilled,
  fs24Suitcase,
} from '@cof/fs-icons';
import { style } from './edit-card.component.style.js';
import '@cof/fs-typography-wc/fs-heading.js';
import '@cof/fs-typography-wc/fs-body-text.js';
import '@cof/fs-text-field-wc/fs-text-field.js';
import '@cof/fs-helper-text-wc/fs-helper-text.js';
import '@cof/fs-alert-wc/fs-alert.js';

// import { stratum } from '../../../constants/stratum.js';

class RefiPersonalEditCard extends LitElement {
  constructor() {
    super();
    this.cardTitle = '';
    this.componentId = '';
    this.editing = false;
    this.uneditable = false;
    this.showError = false;
    this.inactive = false;
    this.loading = false;
    this.truncateDisplay = false;

    // Display text: each item in the array will be displayed on a separate line
    this.displayText = [
      // 'John Doe',
      // 'abc@email.com',
      // '555-555-5555',
      // '12/**/1999',
      // '***-**-1234',
    ];

    const icons = [
      fs24Offer,
      fs24Car,
      fs24Bank,
      fs24User,
      fs24Home,
      fs24MoneyBag,
      fs24CloseFilled,
      fs24Suitcase,
    ];
    for (const icon of icons) {
      FsIcon.add(icon);
    }
  }

  static get properties() {
    return {
      cardTitle: { type: String, attribute: 'card-title' },
      componentId: { type: String, attribute: 'component-id' },
      uneditable: { type: Boolean, attribute: 'uneditable' },
      editing: { type: Boolean, attribute: 'editing', reflect: true },
      showError: { type: Boolean, attribute: 'show-error', reflect: true },
      cardIcon: { type: String, attribute: 'card-icon' },
      loading: { type: Boolean, attribute: 'loading', reflect: true },
      displayText: { type: Array, attribute: 'display-text' },
      inactive: { type: Boolean, attribute: 'inactive' },
      truncateDisplay: {
        type: Boolean,
        attribute: 'truncate-display',
        reflect: true,
      },
    };
  }

  static styles = [style, typographyStyles];

  editClicked() {
    this.editing = true;
    this.dispatchEvent(new CustomEvent('edit-clicked', { bubbles: true }));
  }

  cancelClicked() {
    this.dispatchEvent(new CustomEvent('cancel-clicked', { bubbles: true }));
    this.editing = false;
  }

  saveClicked() {
    this.dispatchEvent(new CustomEvent('save-clicked', { bubbles: true }));
    // Event is sent to parent component, which should then call closeEditing in this component
  }

  closeEditing() {
    this.editing = false;
  }

  /*
  tagCheckoutCardInteraction(tagType) {
    // let tagName;
    // const tagValue =
    //   EDIT_CARD_CONST.STRATUM_REFS[this.cardTitle.toLowercase()].CARD_NAME;
    // if (tagType === EDIT_CARD_CONST.STRATUM_CARD_TAG_TYPE.UNSAVED_EDIT_ERROR) {
    //   tagName = TagKey.CHECKOUT_PAGE_EDIT_COMPONENT_ERROR_MESSAGE_SHOWN;
    // } else {
    //   return;
    // }
    // stratum.publishTag(tagName, {
    //   replacements: {
    //     value: tagValue,
    //   },
    // });
  }
    */

  renderEditButton() {
    if (!this.uneditable && !this.editing) {
      return html`<button
        class=" fs-text-weight--semibold edit-button ${this.inactive
          ? 'fs-text fs-text-color--disabled'
          : 'fs-link-standalone fs-link-standalone--small'}"
        @click="${this.editClicked}"
        ?disabled="${this.inactive}"
        data-cy="${this.componentId}-edit-button"
        aria-label="Edit ${this.cardTitle} info"
      >
        Edit
      </button>`;
    }
    if (!this.uneditable && this.editing) {
      return html`<button
        class="fs-link-standalone fs-link-standalone--small fs-text-weight--semibold edit-button"
        @click="${this.cancelClicked}"
        data-cy="${this.componentId}-cancel-button"
      >
        Cancel
      </button>`;
    }
    return nothing;
  }

  renderEditError() {
    if (this.editing && this.showError) {
      // this.tagCheckoutCardInteraction(
      //   EDIT_CARD_CONST.STRATUM_CARD_TAG_TYPE.UNSAVED_EDIT_ERROR
      // );
      return html`<fs-alert
        type="error"
        role="alert"
        id="${this.componentId}-error"
        data-cy="${this.componentId}-error"
        class="card-alert"
        >You have unsaved changes in this section. Please save or cancel before
        proceeding</fs-alert
      >`;
    }
    return nothing;
  }

  renderDisplayText() {
    if (this.editing) {
      return nothing;
    }

    const div = document.createElement('div');
    let content = '';
    // Render each array item on its own line
    for (const item of this.displayText) {
      content += this.truncateDisplay
        ? '<fs-body-text class="truncate-display">'
        : '<fs-body-text>';
      content += item.toString();
      content += '</fs-body-text>';
    }
    div.innerHTML = content;
    return div;
  }

  renderSaveButton() {
    if (this.editing) {
      return html`<div class="button-row card-content">
        <fs-button
          id="save-${this.componentId}"
          class="save-button"
          variant="primary"
          type="button"
          @click="${this.saveClicked}"
          ?loading="${this.loading}"
          >Save
        </fs-button>
      </div>`;
    }
    return nothing;
  }

  render() {
    return html`
      <div class="review-card ${this.inactive ? 'inactive' : ''}">
        <div class="review-card-content">
          <div class="card-header">
            <div class="icon-and-title">
              <fs-icon
                icon="${this.cardIcon}"
                description="${this.cardTitle}"
                variant="primary"
              ></fs-icon>
              <fs-heading size="normal" level="2" variant="primary">
                ${this.cardTitle}
              </fs-heading>
            </div>
            <div class="edit-button-container">${this.renderEditButton()}</div>
          </div>

          ${this.renderEditError()}

          <div class="card-content ${this.editing ? 'editing' : ''}">
            ${this.renderDisplayText()}
            ${this.editing ? html`<slot></slot>` : nothing}
          </div>

          ${this.renderSaveButton()}
        </div>
      </div>
    `;
  }
}

customElements.define('refi-personal-edit-card', RefiPersonalEditCard);
